export const normalizeDecimal = (value) => {
  return value.replace(/[^0-9.]/g, '')
}

export const normalizeAlphanumeric = (value) => {
  return value.replace(/[^a-zA-Z0-9]/g, '');
}

export const normalizeText = (value) => {
  return value.replace(/[^ñáéíóúa-zÑÁÉÍÓÚA-Z ]/g, '');
}
